import React from "react";
import CommunityCard from "@/components/CommunityCard/CommunityCard";
import { COMMUNITY_CONTENT } from "@/config/communityConfig";

interface Props {
  loggedInUser: { role: string } | null;
  showK12Zone: boolean;
  showLearningCoachCommunity: boolean;
  communityLink?: string;
  displayK12ZoneLink?: string;
  /** When true, links do not navigate (teacher read-only view). */
  disableLinks?: boolean;
}

const CommunityZoneSection: React.FC<Props> = ({
  loggedInUser,
  showK12Zone,
  showLearningCoachCommunity,
  communityLink,
  displayK12ZoneLink,
  disableLinks = false,
}) => {
  const link = (url?: string) => (disableLinks ? '#' : url);
  return (
    <>
      {/* 2-Block Case */}
      {loggedInUser?.role === "LEARNING_COACH" && showK12Zone && showLearningCoachCommunity && (
          <div className="card card--white card--nested">
            <div className="card__topblock">
              <div className="card__titleblock">
                <div className="card__eyebrow">{COMMUNITY_CONTENT.titleEyebrow}</div>
                <h3 className="card__header">{COMMUNITY_CONTENT.titleHeader}</h3>
              </div>
              <p className="card__description">{COMMUNITY_CONTENT.titleDescription}</p>
            </div>
            <div className="community_zone_block">
              <CommunityCard type="learningCoach" linkUrl={link(communityLink)} buttonDisabled={disableLinks} />
              <CommunityCard type="student" linkUrl={link(displayK12ZoneLink)} buttonDisabled={disableLinks} />
            </div>
          </div>
        )}

      {/* 1-Block Case COMMUNITY only */}
      {loggedInUser?.role === "LEARNING_COACH" && !showK12Zone && showLearningCoachCommunity && (
          <div className="card card--white card--nested">
            <div className="community_zone_block">
              <div className="card__topblock">
                <div className="card__titleblock">
                  <div className="card__eyebrow">{COMMUNITY_CONTENT.titleEyebrow}</div>
                  <h2 className="card__header">{COMMUNITY_CONTENT.titleHeader}</h2>
                </div>
                <p className="card__description">{COMMUNITY_CONTENT.titleDescription}</p>
              </div>
              <CommunityCard type="learningCoach" linkUrl={link(communityLink)} />
            </div>
          </div>
        )}

      {/* 1-Block Case K12ZONE only */}
      {loggedInUser?.role === "STUDENT" && showK12Zone && (
        <div className="card card--white card--nested">
          <div className="community_zone_block">
            <div className="card__topblock">
              <div className="card__titleblock">
                <div className="card__eyebrow">{COMMUNITY_CONTENT.titleEyebrow}</div>
                <h3 className="card__header">{COMMUNITY_CONTENT.titleHeader}</h3>
              </div>
              <p className="card__description">{COMMUNITY_CONTENT.titleDescription}</p>
            </div>
            {/* K12Zone Card different content */}
            <CommunityCard
                type="student"
                linkUrl={link(displayK12ZoneLink)}
                orientation="vertical"
                buttonTextOverride="Enter the K12 Zone"
                buttonDisabled={disableLinks}
                descriptionOverride="Online school is more social than ever when you find friends and fun in the K12 Zone! From scavenger hunts to art competitions and school assemblies, you'll want to explore everything the K12 Zone has to offer. Try it out today!"
            />
          </div>
        </div>
      )}
    </>
  );
};

export default CommunityZoneSection;
